import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaKeyboard, FaPaintBrush, FaMagic, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Restauração de Teclado
import { LuPiano } from "react-icons/lu";
import { GiPianoKeys } from 'react-icons/gi';
import SeoHead from "../../components/Menu/components/SeoHead";

import '../../assets/css/restauracaoteclado.css'; // CSS específico para esta página

const RestauracaoTeclado = () => {
  // Array com as imagens da galeria
const galleryImages = [
  { 
    id: 1, 
    src: '/img/teclado/1.jpg', 
    alt: 'Acabamento tecla a tecla no capricho' 
  },
  { 
    id: 2, 
    src: '/img/teclado/2.jpg', 
    alt: 'Correção de alinhamento perfeito' 
  },
  { 
    id: 3, 
    src: '/img/teclado/3.jpg', 
    alt: 'Composição visual com a laqueação do móvel' 
  },
  { 
    id: 4, 
    src: '/img/teclado/4.jpg', 
    alt: 'Troca da cobertura plástica das teclas' 
  },
  { 
    id: 5, 
    src: '/img/teclado/5.jpg', 
    alt: 'Manutenção completa' 
  },
];

const restauracaoTecladoSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Restauração de Teclado de Piano",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Serviço especializado em restauração de teclado de piano, com opções de clareamento do marfim, pintura ou troca da cobertura plástica das teclas, além de ajustes mecânicos.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/restauracao-teclado"
};



  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];


  return (
    <div className="restauracao-teclado-container">
      <SeoHead
  title="Restauração de Teclado de Piano | Waldir Pianos"
  description="Renove o teclado do seu piano com clareamento de marfim, pintura ou troca de cobertura. Ajustes mecânicos para um toque perfeito e visual impecável."
  keywords="restauração teclado piano, clareamento marfim piano, pintura teclado piano, troca teclas piano, conserto teclado piano, Waldir Pianos"
  image="/img/restauracao-teclado/1.jpg"
  url="https://pianoswaldir.com.br/restauracao-teclado"
  canonicalUrl="https://pianoswaldir.com.br/restauracao-teclado"
  schemaMarkup={restauracaoTecladoSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="restauracao-teclado-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="restauracao-teclado-header-content">
          <motion.h1
            className="restauracao-teclado-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaKeyboard className="restauracao-teclado-title-icon" />
            Restauração do Teclado
            <span className="restauracao-teclado-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="restauracao-teclado-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Toque a perfeição em cada tecla
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="restauracao-teclado-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="restauracao-teclado-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="restauracao-teclado-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="restauracao-teclado-section-title">
              <GiPianoKeys className="restauracao-teclado-section-icon" />
              Aspectos Mecânicos e Visuais
            </h2>

            <p className="restauracao-teclado-classic-text">
              "Grande parte dos ajustes nos aspectos mecânicos do teclado são reparados no processo de regulagem do piano. Como alinhamentos, jogos e folgas. Ainda podem ser trocados pinos de suporte e embuchamento (pequenos feltros) para um ajuste perfeito."
            </p>

            <div className="restauracao-teclado-modern-text">
              <p>No aspecto visual, existem basicamente 3 opções:</p>
              <h3>Clareamento do Marfim</h3>
              <p>Pianos com as tradicionais teclas de marfim, possuem alto valor histórico e são bastante apreciados por sua originalidade. Porém trata-se de um material naturalmente mais amerelado e esta característica se acentua ao longo dos anos. Para não interferir nesta propriedade do material, o processo utilizado para restauração é a limpeza e polimento com produtos adequados que proporcionam um leve clareamento sem descaracteriza-lo.</p>

              <h3>Pintura do Teclado</h3>
              <p>Se a opção for por um teclado branco, a pintura é uma técnica que possui um bom custo benefício e acompanha a reforma visual do móvel, por exemplo.</p>

              <h3>Troca da Cobertura do Teclado</h3>
              <p>Com exceção das teclas de marfim, os Pianos possuem uma cobertura plástica em suas teclas, quando estas se danificam ou procura-se readquirir o aspecto de novo. Recomenda-se a troca destas coberturas plásticas.</p>
            </div>

            <div className="restauracao-teclado-benefits-grid">
              <div className="restauracao-teclado-benefit-item">
                <FaKeyboard className="restauracao-teclado-benefit-icon" />
                <span>Alinhamento e ajuste mecânico</span>
              </div>
              <div className="restauracao-teclado-benefit-item">
                <FaPaintBrush className="restauracao-teclado-benefit-icon" />
                <span>Clareamento ou pintura das teclas</span>
              </div>
              <div className="restauracao-teclado-benefit-item">
                <FaCheckCircle className="restauracao-teclado-benefit-icon" />
                <span>Troca de coberturas plásticas</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

<motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Restauração do Teclado</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="restauracao-teclado-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="restauracao-teclado-footer-text">Dê uma nova vida ao seu teclado!</p>
        <motion.a
          href="tel:1122565987"
          className="restauracao-teclado-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default RestauracaoTeclado;